module.exports = __webpack_public_path__ + "fonts/Veneer.081b53a4.ttf";